import React, { FC, useEffect, useRef, useState } from "react";
import { CollapsableProps } from "./Collapsable.types";
import styles from "./Collapsable.module.scss";

const Collapsable: FC<CollapsableProps> = ({ children, open, speed, ...rest }) => {
  const [height, setHeight] = useState<string>(open ? "auto" : "0px");
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (open) {
      setHeight(ref.current?.scrollHeight + "px");
    } else {
      setHeight(ref.current?.scrollHeight + "px");
      window.requestAnimationFrame(() => {
        setHeight("0px");
      });
    }
  }, [open]);

  const handleOnTransitionEnd: React.TransitionEventHandler<HTMLDivElement> = (event) => {
    if(event.currentTarget.style.height !== "0px" && open){
      setHeight("auto");
    }
  };

  return (
    <div
      {...rest}
      className={[styles.Collapsable, rest.className].join(" ")}
      style={{...rest.style, transitionDuration: `${speed}ms`, ...rest.style , height}}
      onTransitionEnd={handleOnTransitionEnd}
      data-testid="Collapsable"
      ref={ref}
    >
      {children}
    </div>
  );

};

export default Collapsable;
